<app-template-select [disabled]="disabled" [value]="value" [control]="control" [options]="options" [multiple]="multiple" [label]="label" />
